export default{
    
    lista:{
        method:'get',
        url:'boletins/tabela/lista'
    },
    pesquisa:{
        method:'get',
        url:'boletins/tabela/pesquisa{/id}'
    },
    cadastra:{
        method:'post',
        url:'boletins/tabela/cadastro'
    },
    delete:{
        method:'delete',
        url:'boletins/tabela/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'boletins/tabela/editar{/id}'
    },
    duplicar:{
        method:'get',
        url:'boletins/tabela/ferramenta/duplica{/id}'
    },
    update:{
        method:'post',
        url:'boletins/tabela/update'
    },
    numero:{
        method:'post',
        url:'boletins/cartaoponto/numero/max'
    }
}